export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => ([])
    },
  },

  data() {
    return {
      tempFrom: null,
      tempTo: null,
    };
  },

  watch: {
    'values.from': {
      handler(val) {
        this.tempFrom = val
      },
      immediate: true
    },
    'values.to': {
      handler(val) {
        this.tempTo = val
      },
      immediate: true
    }
  },

  computed: {
    values() {
      if (!this.value.length) {
        return {
          from: null,
          to: null,
        };
      }

      const {from, to} = this.value[0];

      return {
        from: parseInt(from, 10),
        to: parseInt(to, 10),
      };
    },
    minMax() {
      const [ predefinedValues ] = this.options;
      const { min, max } = predefinedValues;

      return {
        min: parseInt(min, 10),
        max: parseInt(max, 10),
      };
    },
    from() {
      if (this.tempFrom !== null) {
        return this.tempFrom;
      } else if (this.values.from !== null) {
        return this.values.from;
      }

      return this.minMax.min;
    },
    to() {
      if (this.tempTo !== null) {
        return this.tempTo
      } else if (this.values.to !== null) {
        return this.values.to
      }

      return this.minMax.max;
    },
  },

  methods: {
    updatePrice({ from, to }) {
      this.tempFrom = from;
      this.tempTo = to;
    },
    applyFilter() {
      const from = new String(this.from);
      const to = new String(this.to);

      this.$emit('apply', {
        id: this.name,
        value: [
          {
            from,
            to,
          },
        ]
      });
    },
    localClear() {
      this.tempFrom = null;
      this.tempTo = null;
    },
    clear() {
      this.localClear();
      this.$emit('clear', this.name);
    },
  }
}